import { app } from '../../bootstrap/core';
import { ticketErrorState, ticketErrorStateName } from './ticketError.state';
import { ticketErrorComponent } from './ticketError.component';

app.config(ticketErrorState);
app.constant('ticketErrorStateName', ticketErrorStateName);
app.component(ticketErrorComponent.name, ticketErrorComponent);
